import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledFormControlLabel, StyledCheckbox, StyledIcon, StyledCheckedIcon } from './Checkbox.styles.js';
const _excluded = ["label", "checkboxSize", "color", "mr", "customColor", "boxBorderColor", "boxBackgroundColor", "controlStyle"];
function Checkbox(_ref) {
  let {
      label,
      checkboxSize,
      color,
      mr,
      customColor,
      boxBorderColor,
      boxBackgroundColor,
      controlStyle
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(StyledFormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(StyledCheckbox, _extends({
      color: color,
      customColor: customColor,
      icon: /*#__PURE__*/React__default.createElement(StyledIcon, {
        checkboxSize: checkboxSize,
        color: color,
        boxBorderColor: boxBorderColor,
        boxBackgroundColor: boxBackgroundColor
      }),
      checkedIcon: /*#__PURE__*/React__default.createElement(StyledCheckedIcon, {
        checkboxSize: checkboxSize,
        color: color,
        customColor: customColor,
        boxBorderColor: boxBorderColor,
        boxBackgroundColor: boxBackgroundColor
      }),
      checkboxSize: checkboxSize,
      disableRipple: true,
      mr: mr,
      label: label
      // onClick={(e) => e.stopPropagation()}
    }, otherProps)),
    label: label,
    sx: controlStyle
  });
}
Checkbox.propTypes = {
  /**
   * The checkbox text.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'warning']),
  /**
   * The checkbox size.
   */
  checkboxSize: PropTypes.number,
  /**
   * The checkbox margin right.
   */
  controlStyle: PropTypes.shape({}),
  mr: PropTypes.number,
  customColor: PropTypes.string,
  boxBorderColor: PropTypes.string,
  boxBackgroundColor: PropTypes.string
};
Checkbox.defaultProps = {
  label: null,
  color: 'secondary',
  checkboxSize: 16,
  mr: 4,
  controlStyle: {},
  customColor: null,
  boxBorderColor: null,
  boxBackgroundColor: null
};
export { Checkbox as default };